/*eslint-disable */
const $ = window.jQuery = require('jquery');

import bucketTreeView from '@/components/researchPapers/shelf/bucket-tree-view';
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import newBucketFolder from '@/components/researchPapers/shelf/new-bucket-folder';
import newSubBucketFolder from '@/components/researchPapers/shelf/new-subbucket-folder';
import removeBucket from '@/components/researchPapers/shelf/delete-bucket';
import renameBucketname from '@/components/researchPapers/shelf/rename-bucket';

export default {
  name: 'left-sidebar-rp',
  components: {
    'new-bucket-folder' : newBucketFolder,
    'new-sub-bucket-folder' : newSubBucketFolder,
    'bucket-tree-view' : bucketTreeView,
    'rename-bucket' : renameBucketname,
    'remove-bucket' : removeBucket,
  },
  props: [],
  data () {
    return {
      newBucketFolderPopupState:false,
      bucketListDetails:{},
      bucketListResults:[],
      removeBucketPopupState:false,
      removeBucketId:'',
      updateBucketPopupState:false,
      updateBucketDetail:'',
      newSubBucketFolderPopupState:false,
      newSubBucketFolderId:'',
    }
  },
  computed: {
    ...mapGetters([
      'getBucketListOfAwerackGetters',
    ]),
    getBucketListDetailsFun(){
      this.bucketListDetails = this.$store.getters.getBucketListOfAwerackGetters.data;
      return
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails != undefined){
        this.bucketListResults = this.bucketListDetails.results
      }
    }
  },
  mounted () {
    this.getBucketListDetailsFun
    this.setIntialStateOfBucket
    bus.$on('newBucketFolderPopupStateBus', (data) => {
      this.newBucketFolderPopupState = data;
    });
    bus.$on('newSubBucketFolderPopupStateBus', (data) => {
      this.newSubBucketFolderPopupState = data;
    });
    bus.$on('removeBucketPopupStateBus', (data) => {
      this.removeBucketPopupState = data;
    });
    bus.$on('updateBucketPopupStateBus', (data) => {
      this.updateBucketPopupState = data;
    });
    $('.allfoldercollapsed').click(function(){
      if($('.sub_folder_dd ').hasClass('show_sub_bucket')){
        $('.sub_folder_dd ').removeClass('show_sub_bucket')
        $(this).removeClass('open')
      }else{
        $('.sub_folder_dd ').addClass('show_sub_bucket')
        $(this).addClass('open')
      }
    })
  },
  methods: {
    bucketDetailRouting(bucketID){
      if (bucketID != this.$route.params.bucketId) {
        this.$router.push({ name: 'bucketDetails', params: { bucketId: bucketID } })
        this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: bucketID }).then((res) => {
        }).catch((err) => {
        })
      }
    },
    getBucketListAgainMethod(){
      this.$store.dispatch('getBucketListOfAwerackFun').then((res)=>{
      }).catch((err) => {})
    },
    openNewBcuketFolderPopup(){
      this.newBucketFolderPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    removeBucketPopupOpenMethod(itemId){
      this.removeBucketId = itemId
      this.removeBucketPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    openRenameBucketPopup(data){
      this.updateBucketDetail = data
      this.updateBucketPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    addNewSubBucketFolderMethod(id){
      this.newSubBucketFolderPopupState = true
      this.newSubBucketFolderId = id
      document.body.classList.add('body_right_scroll_remove')
    },
  },
  watch:{
    getBucketListDetailsFun(){
      return this.$store.getters.getResearchGroupForAwerackGetters
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails != undefined){
        this.bucketListResults = this.bucketListDetails.results
      }
    }
  }
}